import ReactModal from "react-modal";
import { useRecoilState } from "recoil";
import { ModalConfirmState } from "stores/atoms/modalConfirmState";

/**
 * 共通確認選択モーダル
 */
export default function ModalConfirm(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [modalConfirmState, setModalConfirmState] =
    useRecoilState(ModalConfirmState);

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * モーダルを閉じる処理
   */
  const onClose = () => {
    setModalConfirmState({
      ...modalConfirmState,
      open: false,
    });
  };

  /**
   * OKボタン押下時の処理
   */
  const onSubmit = () => {
    modalConfirmState.onSubmit();
    onClose();
  };

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <ReactModal
        isOpen={modalConfirmState.open}
        onRequestClose={onClose}
        style={{
          overlay: {
            zIndex: 2000,
            backgroundColor: "rgba(30, 30, 30,0.5)",
          },
          content: {
            maxWidth: "500px",
          },
        }}
        className="ReactModal__Content__Custom"
        ariaHideApp={false}
      >
        <div
          id="settings-modal"
          className="modal2 modal-content rounded-4 "
          style={{ maxWidth: "none" }}
        >
          <div className="modal-body">
            {/* タイトル */}
            <h3
              className="modal-title text-center mt-5"
              id="settings-modal-label"
            >
              {modalConfirmState.title}
            </h3>
            {/* 本文 */}
            <div className="modal-text text-center mt-3 ms-3 me-3">
              {modalConfirmState.message}
            </div>
          </div>
          <div className="modal-footer border-top-0 justify-content-center mt-3">
            <button
              onClick={onClose}
              type="button"
              className="btn btn-secondary"
            >
              キャンセル
            </button>
            <button onClick={onSubmit} type="button" className="btn btn-submit">
              OK
            </button>
          </div>
        </div>
      </ReactModal>
    </>
  );
}
